/* eslint-disable max-statements */
import React from 'react';
import { AppError } from 'src/redux/types';
import styles from './styles.module.scss';
import icClose from 'assets/svg/ic_close.svg';
import Modal from 'src/Components/Modal';
import { CosmeticStatus } from 'src/utils/types';
import { useTypedDispatch, useTypedSelector } from 'src/redux/utils';
import { stopSellingCosmetic } from 'src/redux/actions';
import Button from 'src/Pages/CosmeticDetail/Components/Button';

const StopCosmeticSaleTransactionModal = ({
  onClose,
  cosmetic,
  onFailure,
  onCompleted
}) => {
  const dispatch = useTypedDispatch();
  const stopSellingLoading = useTypedSelector(state => state.stopSellingCosmetic.loading);
  const isItemListing = cosmetic.cosmeticInfo.status === CosmeticStatus.SELLING;

  const onButtonPressed = async () => {
    const {
      blockchainId
    } = cosmetic;
    if (!blockchainId) return;
    const {
      data,
      error
    } = await dispatch(stopSellingCosmetic({
      blockchainId
    }));

    if (error !== undefined && error !== AppError.NO_ERROR) {
      onFailure(error);
      return;
    }

    if (data) {
      onCompleted();
    }
  };

  return /*#__PURE__*/React.createElement(Modal, null, /*#__PURE__*/React.createElement("div", {
    className: styles.modal
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.header
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.label
  }, /*#__PURE__*/React.createElement("span", null, "Stop Selling")), /*#__PURE__*/React.createElement("button", {
    className: styles.close,
    disabled: stopSellingLoading,
    onClick: onClose
  }, /*#__PURE__*/React.createElement("img", {
    src: icClose
  }))), /*#__PURE__*/React.createElement("div", {
    className: styles.detailContainer
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.subtitle
  }, /*#__PURE__*/React.createElement("span", null, "Are you sure to cancel selling this item?")), /*#__PURE__*/React.createElement("div", {
    className: styles.buttonGroup
  }, /*#__PURE__*/React.createElement(Button, {
    disabled: stopSellingLoading,
    onClick: onClose,
    title: "Cancel",
    type: "secondary"
  }), stopSellingLoading ? /*#__PURE__*/React.createElement(Button, {
    disabled: true,
    loading: true,
    title: "Processing..."
  }) : /*#__PURE__*/React.createElement(Button, {
    className: styles.button,
    onClick: onButtonPressed,
    disabled: !isItemListing,
    title: "Stop selling"
  })))));
};

export default StopCosmeticSaleTransactionModal;